<template>
    <div>
        <base-expandable v-if="text">
            <template v-slot:short>
                <div class="whitespace-pre-wrap">{{ excerpt }}</div>
            </template>

            <template v-slot:long>
                <div class="whitespace-pre-wrap">{{ text }}</div>
            </template>

            <template v-slot:trigger="{ isOpen: is_open, toggle }">
                <button
                    v-if="excerpt.length < text.length"
                    class="inline-flex items-center mt-1 text-blue focus:outline-none"
                    @click.prevent="toggle"
                >
                    Read {{ is_open ? 'less' : 'more' }}

                    <base-svg
                        :name="`icon-cheveron-${is_open ? 'up' : 'down'}`"
                        :key="`icon-cheveron-${is_open ? 'up' : 'down'}`"
                        class="w-5 h-5 fill-primary-blue"
                    />
                </button>
            </template>
        </base-expandable>

        <base-na v-else>
            {{ placeholder }}
        </base-na>
    </div>
</template>

<script>
    import _ from 'lodash'

    export default {
        props: {
            text: {
                validator: value => _.isString(value) || _.isNull(value),
                default: null
            },
            length: {
                type: Number,
                default: 300
            },
            placeholder: {
                type: String,
                default: 'n/a'
            }
        },
        computed: {
            excerpt () {
                return _.truncate(this.text, {
                    length: this.length
                })
            }
        }
    }
</script>
